import { websiteUrls } from "../constants/website-urls.js";

export const productUrl = (url, language_code) => {
    let baseUrl = websiteUrls[language_code] ?? websiteUrls.en
    if (['be_fr', 'lu_fr'].includes(language_code)) {
        baseUrl = baseUrl.endsWith('/fr') ? baseUrl.slice(0, -'/fr'.length) : baseUrl;
    }
    return `${baseUrl}/${url}`
}

// ERP-uploaded product images are stored as absolute URLs — pass them through.
export const getProductImageUrl = (path) => /^https?:\/\//i.test(path ?? '') ? path : `${websiteUrls.nl}/files/photos/${path}`
export const getProductImageUrlResized = (path, width = 100) => `${websiteUrls.nl}/thumb.php?img=/files/photos/${path}&w=${width}`

// CMS search results may return either a bare filename or an already-prefixed
// relative path - handle both instead of assuming one convention.
export const getProductThumbnailUrl = (path) => {
    if (!path) return null
    if (/^https?:\/\//i.test(path)) return path
    const relative = path.replace(/^\//, '')
    return relative.startsWith('files/photos/')
        ? `${websiteUrls.nl}/${relative}`
        : `${websiteUrls.nl}/files/photos/${relative}`
}